module.exports = __webpack_public_path__ + "static/Joy.e7cdd615.png";